import { formatJalaliDate, formatJalaliYear } from "./dateFormat";
// Modern A4 Sale Return Invoice Printing
export const printSaleReturn = (saleReturn) => {
  const printWindow = window.open('', '_blank');

  const brandaranLogo = `${window.location.origin}/logo.jpeg`;

  const marsLogo = `${window.location.origin}/logo.jpeg`;
  
  const currencySymbol = saleReturn.sale_details?.currency_details?.symbol || 
                        saleReturn.sale_details?.currency_details?.title || 'AF';
  
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return formatJalaliDate(date);
  };

  const calculateTotalRefund = () => {
    return saleReturn.return_items.reduce((sum, item) => {
      const val = item.calculated_refund_amount?.parsedValue ?? 
                  parseFloat(item.refund_amount) ?? 0;
      return sum + val;
    }, 0).toFixed(2);
  };

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Sale Return Invoice</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          font-size: 14px;
          line-height: 1.6;
          color: #333;
          background: white;
        }
        .invoice {
          max-width: 210mm;
          margin: 0 auto;
          padding: 20mm;
          background: white;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 30px;
          padding-bottom: 20px;
          border-bottom: 3px solid #f44336;
          gap: 16px;
        }
        .company-info {
          flex: 1;
        }
        .company-brand {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 10px;
        }
        .company-logos {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }
        .company-logo {
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #f2cfd2;
          border-radius: 10px;
          background: #fff;
          padding: 5px 7px;
        }
        .company-logo img {
          display: block;
          object-fit: contain;
        }
        .company-logo.brandaran img {
          width: 72px;
          height: 72px;
        }
        .company-logo.mars img {
          width: 145px;
          height: 60px;
        }
        .company-name {
          font-size: 28px;
          font-weight: bold;
          color: #f44336;
          margin-bottom: 5px;
        }
        .company-contact {
          color: #666;
          font-size: 14px;
        }
        .invoice-info {
          text-align: right;
          flex: 1;
        }
        .invoice-title {
          font-size: 32px;
          font-weight: bold;
          color: #f44336;
          margin-bottom: 10px;
        }
        .invoice-number {
          font-size: 18px;
          color: #666;
        }
        .details-section {
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
        }
        .detail-box {
          background: #fff3f3;
          padding: 20px;
          border-radius: 8px;
          flex: 1;
          margin: 0 10px;
          border-left: 4px solid #f44336;
        }
        .detail-box:first-child { margin-left: 0; }
        .detail-box:last-child { margin-right: 0; }
        .detail-title {
          font-weight: bold;
          color: #f44336;
          margin-bottom: 10px;
          font-size: 16px;
        }
        .detail-content {
          color: #666;
        }
        .items-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 30px;
          background: white;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        .items-table th {
          background: #f44336;
          color: white;
          padding: 15px;
          text-align: left;
          font-weight: 600;
        }
        .items-table td {
          padding: 15px;
          border-bottom: 1px solid #eee;
        }
        .items-table tr:hover {
          background: #fff3f3;
        }
        .items-table tr:last-child td {
          border-bottom: none;
        }
        .text-right { text-align: right; }
        .text-center { text-align: center; }
        .summary-section {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 30px;
        }
        .summary-box {
          background: #fff3f3;
          padding: 25px;
          border-radius: 8px;
          min-width: 300px;
          border-left: 4px solid #f44336;
        }
        .summary-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          padding: 5px 0;
        }
        .summary-row.total {
          border-top: 2px solid #f44336;
          padding-top: 15px;
          margin-top: 15px;
          font-weight: bold;
          font-size: 18px;
          color: #f44336;
        }
        .reason-section {
          background: #fff3f3;
          padding: 20px;
          border-radius: 8px;
          margin-bottom: 30px;
          border-left: 4px solid #f44336;
        }
        .reason-title {
          font-weight: bold;
          color: #f44336;
          margin-bottom: 10px;
          font-size: 16px;
        }
        .footer {
          text-align: center;
          margin-top: 40px;
          padding-top: 20px;
          border-top: 1px solid #eee;
          color: #666;
        }
        .thank-you {
          font-size: 18px;
          font-weight: bold;
          color: #f44336;
          margin-bottom: 10px;
        }
        @media print {
          body { margin: 0; padding: 0; }
          .invoice { 
            box-shadow: none; 
            max-width: none;
            padding: 15mm;
          }
          @page { 
            size: A4; 
            margin: 0;
          }
        }
      </style>
    </head>
    <body>
      <div class="invoice">
        <!-- Header -->
        <div class="header">
          <div class="company-info">
            <div class="company-brand">
              <div class="company-logos">
                <div class="company-logo brandaran">
                  <img src="${brandaranLogo}" alt="شرکت تجارتی توکل نورزی Logo" />
                </div>
                <div class="company-logo mars">
                  <img src="${marsLogo}" alt="Mars Remedies Pvt. Ltd. Logo" />
                </div>
              </div>
            </div>
            <div class="company-name">شرکت تجارتی توکل نورزی</div>
            <div class="company-contact">
              0776000248 - 0700800817<br>
              📧 wahidtajzoi737@gmail.com
            </div>
          </div>
          <div class="invoice-info">
            <div class="invoice-title">SALE RETURN</div>
            <div class="invoice-number">#${saleReturn.id}</div>
          </div>
        </div>

        <!-- Details Section -->
        <div class="details-section">
          <div class="detail-box">
            <div class="detail-title">Customer:</div>
            <div class="detail-content">
              <strong>${saleReturn.sale_details?.customer_details?.name || 'Walk-in Customer'}</strong><br>
              ${saleReturn.sale_details?.customer_details?.phone || ''}<br>
              ${saleReturn.sale_details?.customer_details?.address || ''}
            </div>
          </div>
          <div class="detail-box">
            <div class="detail-title">Return Details:</div>
            <div class="detail-content">
              <strong>Return Date:</strong> ${formatDate(saleReturn.return_date)}<br>
              <strong>Original Sale:</strong> #${saleReturn.sale || saleReturn.sale_details?.id || 'N/A'}<br>
              <strong>Sale Date:</strong> ${formatDate(saleReturn.sale_details?.sale_date)}<br>
              <strong>Items Returned:</strong> ${saleReturn.return_items?.length || 0}
            </div>
          </div>
        </div>

        <!-- Reason Section -->
        ${saleReturn.reason ? `
        <div class="reason-section">
          <div class="reason-title">Return Reason:</div>
          <div class="detail-content">${saleReturn.reason}</div>
        </div>
        ` : ''}

        <!-- Items Table -->
        <table class="items-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th class="text-center">Return Qty</th>
              <th class="text-right">Sale Price</th>
              <th class="text-right">Refund Amount</th>
              <th class="text-center">Return Date</th>
            </tr>
          </thead>
          <tbody>
            ${saleReturn.return_items && saleReturn.return_items.length > 0 ? 
              saleReturn.return_items.map((item, index) => {
                const name = item.sale_item_details?.product?.name || `Product ${index + 1}`;
                const qty = item.return_quantity;
                const salePrice = parseFloat(item.sale_item_details?.sale_price || 0).toFixed(2);
                const refundAmount = (item.calculated_refund_amount?.parsedValue ?? 
                                   parseFloat(item.refund_amount) ?? 0).toFixed(2);
                const returnDate = formatDate(item.created_at);
                return `
                  <tr>
                    <td>${index + 1}</td>
                    <td><strong>${name}</strong></td>
                    <td class="text-center">${qty}</td>
                    <td class="text-right">${salePrice} ${currencySymbol}</td>
                    <td class="text-right"><strong>${refundAmount} ${currencySymbol}</strong></td>
                    <td class="text-center">${returnDate}</td>
                  </tr>
                `;
              }).join('')
              : '<tr><td colspan="6" class="text-center">No items found</td></tr>'
            }
          </tbody>
        </table>

        <!-- Summary Section -->
        <div class="summary-section">
          <div class="summary-box">
            <div class="summary-row total">
              <span>Total Refund Amount:</span>
              <span>${calculateTotalRefund()} ${currencySymbol}</span>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="footer">
          <div class="thank-you">Thank you for your understanding!</div>
          <div>© ${formatJalaliYear()} شرکت تجارتی توکل نورزی - All rights reserved</div>
          <div style="margin-top:4px;font-size:10px;color:#999;">Powered by Afghan Cosmos IT Solutions </div>
        </div>
      </div>
      
      <script>
        window.onload = function() {
          setTimeout(() => {
            window.print();
            window.close();
          }, 1000);
        };
      </script>
    <div style="margin-top:12px;text-align:center;font-size:11px;color:#6b7280;">Powered by Afghan Cosmos IT Solutions | www.afghancosmos.com</div></body>
    </html>
  `;

  printWindow.document.write(html);
  printWindow.document.close();
};

export default { printSaleReturn };


